import { SquareLoader } from "react-spinners";
import React from "react";

export default function LoaderView() {
  return <SquareLoader color="#252525" />;
}
